import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-footer',
  templateUrl: './admin-footer.component.html',
  styleUrls: ['./admin-footer.component.css']
})
export class AdminFooterComponent implements OnInit {
  rights_reserve:string="Powered by Scanfluence Software Inc. | © 2024. All rights reserved."
  constructor() { }

  ngOnInit() {
  }


}
